var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hoc-contract-button fz-12",attrs:{"data-cy":_vm.$UI.Button.Admin.Documents.AddContract}},[_c('i',{staticClass:"fal fa-file-plus mr-2"}),_vm._v(" "+_vm._s(_vm.btnAddText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }